<template>
  <div id="PassengerForm" class="container">
    <form @submit.prevent="addPassenger(passenger)">
      <div class="form-row">
        <div class="col">
          <label>First Name</label>
          <input
            type="text"
            v-model="passenger.first_name"
            class="form-control"
            placeholder="First name"
          />
        </div>

        <div class="col">
          <label>Last Name</label>
          <input
            type="text"
            v-model="passenger.second_name"
            class="form-control"
            placeholder="Last name"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <label>Phone Number</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">+254</span>
            </div>
            <input
              type="tel"
              v-model="passenger.msisdn"
              class="form-control"
              aria-describedby="basic-addon1"
            />
          </div>
        </div>

        <div class="col">
          <label>Age</label>
          <input
            type="number"
            v-model.number="passenger.age"
            class="form-control"
            placeholder="18"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <label>Nationality</label>
          <select v-model="passenger.nationality" class="form-control">
            <option>Kenya</option>
            <option>Uganda</option>
            <option>Tanzania</option>
            <option>Ethopia</option>
            <option>Somalia</option>
            <option>South Sudan</option>
          </select>
        </div>

        <div class="col" v-if="passenger.nationality === 'Kenya'">
          <label>National ID Number</label>
          <input
            type="text"
            class="form-control"
            v-model="passenger.national_id"
          />
        </div>

        <div class="col" v-if="passenger.nationality !== 'Kenya'">
          <label>Passport Number</label>
          <input
            type="text"
            class="form-control"
            v-model="passenger.passport_no"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <label>Town of Residence</label>
          <input
            type="text"
            v-model="passenger.town"
            class="form-control"
            placeholder="Nairobi"
          />
        </div>

        <div class="col">
          <label>Area of Residence</label>
          <input
            type="text"
            v-model="passenger.area"
            class="form-control"
            placeholder="Githurai"
          />
        </div>
      </div>

      <div class="d-flex justify-content-center" style="margin-top: 1rem">
        <button class="btn btn-primary btn-lg">Add Passenger</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "PassengerForm",
  data() {
    return {
      passenger: {
        first_name: "",
        second_name: "",
        msisdn: "+254",
        age: "",
        person_type: "adult",
        nationality: "",
        national_id: "",
        passport_no: "",
        town: "",
        area: "",
      },
    };
  },
  methods: {
    addPassenger(passenger) {
      axios({
        method: "post",
        url: "/passenger/",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        data: passenger,
      });
    },
  },
};
</script>

<style scoped>
form {
  margin-bottom: 2rem;
}
</style>
